<template>
   <div>
      <h1 class="text-3xl font-bold mb-3 mt-10">Muistutusmenettelylomake</h1>
      <h2 class="text-xl font-bold mb-1">Muistutusoikeus varhaiskasvatuksen toiminnasta</h2>
      <p class="mb-3">Lapsella on oikeus turvalliseen ja laadukkaaseen varhaiskasvatukseen. Toisinaan huoltajilla herää varhaiskasvatusta koskevia kysymyksiä tai tyytymättömyyttä toimintaan. Näissä tilanteissa kannattaa asian selvittämiseksi olla ensisijaisesti yhteydessä henkilöstöön tai tarvittaessa päiväkodinjohtajaan.</p>
      <p class="mb-3">Jos asiat eivät omassa varhaiskasvatuspaikassa keskustellen selviä, huoltajien on mahdollista tehdä asiasta muistutus (Varhaiskasvatuslaki 54§) päiväkodinjohtajalle tai aluejohtajalle.</p>
      <h3 class="text-xl font-bold mb-2 mt-5">Muistutuksen tekeminen</h3>
         <ol class="list-decimal">
            <li class="mb-2">Asiakas täyttää tämän lomakkeen.</li>
            <li class="mb-2">Muistutus tulee tehdä mahdollisimman yksityiskohtaisesti kertoen mihin asiaan/asioihin on tyytymätön.</li>
            <li class="mb-2">Muistutus käsitellään pääsääntöisesti kuukauden kuluessa muistutuksen tekemisestä. Mikäli asian selvittäminen vaatii pidemmän ajan, ilmoitetaan arvioitu käsittelyaika muistutuksen tekijälle. Muistutukseen vastataan aina kirjallisesti.</li>
            <li class="mb-2">Muistutukseen annettaan perusteltu vastaus, josta selviää, miten asia on selvitetty ja millaisiin jatkotoimiin muistutus on mahdollisesti johtanut.</li>
         </ol>

      <div>
         <label for="child">Lapsen nimi</label>
         <input v-model="payload.child" type="text" id="child" placeholder="Etu- ja sukunimi" />
      </div>

      <div>
         <label for="house">Päiväkoti</label>
         <input v-model="payload.house" type="text" id="house" placeholder="Päiväkodin nimi" />
      </div>

      <div>
         <label>Huoltajan nimi</label>
         <div>
            <input v-model="payload.name" type="text" id="name" placeholder="Etu- ja sukunimi" />
         </div>
      </div>

      <div>
         <label>Huoltajan puhelinnumero</label>
         <div>
            <input v-model="payload.phone" type="phone" id="phone" placeholder="" />
         </div>
      </div>

      <div>
         <label>Huoltajan sähköpostiosoite</label>
         <div>
            <input v-model="payload.email" type="email" id="email" placeholder="essi@esimerkki.fi" />
         </div>
      </div>

      <div>
         <label for="feedback">Kuvaus muistutuksesta</label>
         <div>
            <textarea placeholder="Asiat tai tapahtumat joita muistutus koskee" v-model="payload.feedback" id="feedback" name="" cols="30" rows="5"></textarea>
         </div>
      </div>

      <button @click="submit()" class="btn" type="submit" id="send">Lähetä muistutus</button>
   </div>
</template>

<script>
import Axios from 'axios'

export default {
   name: 'app',

   props: ['store'],

   data () {
      return {
         payload: {
            returning: null,
            contact: null
         }
      }
   },

   components: {
   },

   methods: {
      submit () {
         Axios.post(process.env.VUE_APP_API_URL + '/api/public/v1/inbound/reminder', this.payload).then(
            function (success) { console.log(success) },
            function (error) { console.error(error) }
         )

         this.store.state.sent = true
      }
   },

   computed: {
   }
}
</script>
